
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special",
      function () {
        return require("private-next-pages/special/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special"])
      });
    }
  